import React from 'react'
import styles from './Badge.module.css'

export const Badge = ({ text, children }) => <span className={styles.badge + ' badge badge-light'}>{text}{children}</span>